import request, { client } from './request';
import endpoints, { withAppId } from './endpoints';
import { SharedLink, StorageItem, StorageItemFull } from '../constants/document';

const getDocumentsList = async (): Promise<StorageItem[]> =>
  request({
    url: withAppId(endpoints.documents.full),
    method: 'GET'    
  });

const getDocumentInfo = async (fullPath: string): Promise<StorageItemFull> =>
  request({
    url: withAppId(endpoints.documents.getDocument),
    method: 'POST',
    data:{
      fullPath
    }    
  });


const createSharedLink = async (fullPath: string, startDate:Date, endDate:Date): Promise<SharedLink> =>
  request({
    url: withAppId(endpoints.documents.createSharedLink),
    method: 'POST',
    data:{
      fullPath,
      startDate: `${startDate.getMonth() + 1}/${startDate.getDate()}/${startDate.getFullYear()}`,
      expirationDate: `${endDate.getMonth() + 1}/${endDate.getDate()}/${endDate.getFullYear()}`,
    }    
  });

const openSharedFileLink = async (code: string): Promise<StorageItemFull> =>
  request({
    url: withAppId(endpoints.documents.openSharedFileLink).replace("{code}", code),
    method: 'GET'
  });

const openSharedFolderLink = async (code: string): Promise<StorageItemFull[]> =>
  request({
    url: withAppId(endpoints.documents.openSharedFolderLink).replace("{code}", code),
    method: 'GET'
  });

const deleteDocument = async (fileName: string, folderName:string): Promise<boolean> =>
  request({
    url: withAppId(endpoints.documents.delete),
    method: 'POST',
    data: {
      folder: folderName,
      fileName
    }    
  });

const renameDocument = async (oldFileName: string, newFileName: string, folderName:string): Promise<boolean> =>
  request({
    url: withAppId(endpoints.documents.rename),
    method: 'POST',
    data: {
      folder: folderName,
      oldFileName,
      newFileName
    }    
  });

const renameFolder = async (oldFolderName: string, newFolderName: string, path:string): Promise<boolean> =>
  request({
    url: withAppId(endpoints.documents.folderRename),
    method: 'POST',
    data: {
      oldFolderName,
      newFolderName,
      path
    }    
  });

const deleteFolder = async (folderName:string): Promise<boolean> =>
  request({
    url: withAppId(endpoints.documents.folderDelete),
    method: 'POST',
    data: {
      folder: folderName
    }    
  });

const deleteContentFolder = async (folderName:string): Promise<boolean> =>
  request({
    url: withAppId(endpoints.documents.folderContentDelete),
    method: 'POST',
    data: {
      folder: folderName
    }    
  });

const addFolder = async (newFolderName: string, folderName:string): Promise<boolean> =>
  request({
    url: withAppId(endpoints.documents.folderAdd),
    method: 'POST',
    data: {
      folder: folderName,
      newFolderName
    }    
  });

const downloadFolder = async (folder: string): Promise<Blob> => {
  const response = await client({
    url: withAppId(endpoints.documents.folderDownload),
    method: 'POST',
    data: { folder },
    responseType: 'blob',
  });
  return response.data;
};

const documentsService = {
  getDocumentsList,
  renameDocument,
  renameFolder,
  deleteDocument,
  addFolder,
  deleteFolder,
  deleteContentFolder,
  getDocumentInfo,
  createSharedLink,
  openSharedFileLink,
  openSharedFolderLink,
  downloadFolder,
};

export default documentsService;
